import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";

import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";
const News = () => {
  const history = useHistory();
  const addNews = (news) => {
    const isFormData = news instanceof FormData;
    return fetch(`${API}/add-news`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      body: isFormData ? news : JSON.stringify(news),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const userAddNews = (news, companyId) => {
    const isFormData = news instanceof FormData;
    return fetch(`${API}/user-add-news/${companyId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      body: isFormData ? news : JSON.stringify(news),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const getNews = () => {
    return fetch(`${API}/get-news`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const getNewsWithPage = (page, limit) => {
    return fetch(`${API}/get-news-with-page/${page}/${limit}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const getUserNews = (email) => {
    const query = email ? `?email=${encodeURIComponent(email)}` : "";
    return fetch(`${API}/get-user-news${query}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteNews = (Id) => {
    return fetch(`${API}/delete-news/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteCompanyNews = (Id, email) => {
    const query = email ? `?email=${encodeURIComponent(email)}` : "";
    return fetch(`${API}/company-delete-news/${Id}${query}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updateNews = (news, Id) => {
    const isFormData = news instanceof FormData;
    return fetch(`${API}/update-news/${Id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      body: isFormData ? news : JSON.stringify(news),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updateCompanyNews = (news, Id) => {
    const isFormData = news instanceof FormData;
    return fetch(`${API}/company-update-news/${Id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      body: isFormData ? news : JSON.stringify(news),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const adminApproveNews = (Id) => {
    return fetch(`${API}/admin-approve-news/${Id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const getApprovedCompanyNews = () => {
    return fetch(`${API}/get-approved-company-news`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const getApprovedCompanyNewsWithPage = (page, limit) => {
    return fetch(`${API}/get-approved-company-news-with-page/${page}/${limit}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  return {
    addNews,
    userAddNews,
    getNews,
    deleteNews,
    deleteCompanyNews,
    updateNews,
    updateCompanyNews,
    getUserNews,
    getNewsWithPage,
    adminApproveNews,
    getApprovedCompanyNews,
    getApprovedCompanyNewsWithPage,
  };
};

export default News;
